import { ScreenerSettingName } from '@/hooks/screener-settings';
import {
  ALL_FACILITIES,
  useSelectedFacilityId
} from '@/hooks/useFacilitiesQuery';

import { useScreenerSettingsQuery } from './useScreenerSettingsQuery';

export const useIsBedBoardEnabled = (): boolean => {
  const selectedFacilityId = useSelectedFacilityId();
  const facilityId =
    typeof selectedFacilityId === 'string' &&
    selectedFacilityId !== ALL_FACILITIES
      ? selectedFacilityId
      : undefined;

  const { data } = useScreenerSettingsQuery().useFindOneByFacilityId(
    {
      facilityId: facilityId ?? '',
      settingName: ScreenerSettingName.BedBoardEnabled
    },
    {
      enabled: Boolean(facilityId)
    }
  );

  if (!facilityId) {
    return false;
  }

  return data?.data?.value === 'enabled';
};
